import React, { useState } from "react";
import { Link } from "gatsby";
import _truncate from "lodash.truncate";
import useNewsList from "@hooks/useNewsList";
import { useIntl } from "gatsby-plugin-intl";
import Title from "@components/Title";
import Panel from "@components/Panel";
import { $FONT_COLOR_DARK } from "@models";
import arrowLeft from "@images/news/arrow-l.png";
import arrowRight from "@images/news/arrow-r.png";

const NEWS_NUM_PER_PAGE = 4;

const NewsPage = () => {
  const { locale, formatMessage } = useIntl();
  const { newsList, groupedNewList, GROUP_BY_LIST } = useNewsList();
  const [groupBy, setGroupBy] = useState("");
  const [currPage, setCurrPage] = useState(1);
  const totalPage = Math.ceil(
    (groupBy !== "" ? groupedNewList[groupBy] : newsList).length / NEWS_NUM_PER_PAGE
  );

  return (
    <>
      <section className="news-section">
        <Title page={"news"} locale={locale} />
        <Panel.Tabs>
          {GROUP_BY_LIST.map((el, idx) => (
            <Panel.Tab key={idx} onClick={() => setGroupBy(el.key)} active={el.key === groupBy}>
              {formatMessage({ id: `news-tag-${el.display}` })}
            </Panel.Tab>
          ))}
        </Panel.Tabs>
        <Panel>
          <Panel.Grid>
            {(groupBy !== "" ? groupedNewList[groupBy] : newsList)
              .slice((currPage - 1) * 4, currPage * 4)
              .map((news, idx) => {
                const {
                  path,
                  context: {
                    frontmatter: { date, title, img, tag, summary },
                    internal: { content },
                  },
                } = news;
                const formatted = summary
                  ? summary.replace(/(\r\n|\r|\n)/g, "<br>")
                  : _truncate(content.replace(/(?:\r\n|\r|\n|#)/g, " "), {
                      length: 40,
                      separator: /,?\s+/,
                    });
                return (
                  <Link to={path} key={idx}>
                    <div>
                      <img
                        src={`${process.env.GATSBY_PREFIX}${img}`}
                        style={{ width: "100%" }}
                        alt="news-cover"
                      />
                    </div>
                    <div>
                      <Panel.Title>{title}</Panel.Title>
                      <Panel.Content>{new Date(date).toLocaleDateString()}</Panel.Content>
                      <Panel.Tag> {formatMessage({ id: `news-tag-${tag}` })}</Panel.Tag>
                      <Panel.Content>
                        <div dangerouslySetInnerHTML={{ __html: formatted }} />
                      </Panel.Content>
                    </div>
                  </Link>
                );
              })}
          </Panel.Grid>
        </Panel>
        {/* pagination */}
        {totalPage > 1 && (
          <div style={{ display: "flex" }}>
            <PageButton
              onClick={() => {
                currPage > 1 && setCurrPage(prev => prev - 1);
              }}>
              <img src={arrowLeft} alt="left" style={{ width: "15px" }} />
            </PageButton>
            {new Array(totalPage).fill(1).map((_, idx) => (
              <PageButton
                key={idx}
                active={idx + 1 === currPage}
                onClick={() => {
                  setCurrPage(idx + 1);
                }}>
                {idx + 1}
              </PageButton>
            ))}
            <PageButton
              active={false}
              onClick={() => {
                currPage < totalPage && setCurrPage(prev => prev + 1);
              }}>
              <img src={arrowRight} alt="right" style={{ width: "14px" }} />
            </PageButton>
          </div>
        )}
      </section>
    </>
  );
};

const PageButton = ({ active, onClick, children }) => (
  <div
    style={{
      backgroundColor: active ? "white" : "rgba(0,0,0,0.4)",
      borderRadius: "50%",
      marginRight: "10px",
      width: "30px",
      height: "30px",
      color: active ? $FONT_COLOR_DARK : "#ffffff",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      cursor: "pointer",
    }}
    onClick={onClick}>
    {children}
  </div>
);

export default NewsPage;
